import React from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import fiteAPI from '../fiterAPI';
import XPItem from './XPItem';

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

class LanguageForm extends React.Component {
  constructor() {
    super();

    this.state = {
      language: '',
      proeficiency: '',
      languages: []
    };

    this.handleLanguage = this.handleTextChange('language').bind(this);
    this.handleProeficiency = this.handleTextChange('proeficiency').bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
  }

  componentDidMount() {
    const { languages = [] } = this.props.userProfileData;

    this.setState({
      languages
    });
  }

  async onSaveChanges() {
    this.props.turnOnLoading();
    const { language, proeficiency, languages = [] } = this.state;

    languages.push({
      language,
      proeficiency
    });
    await fiteAPI.updateUser({ languages });
    this.props.setCurrentUser();
  }

  handleTextChange = fieldName => event => {
    const { value } = event.target;
    this.setState({ [fieldName]: value });
  };

  render() {
    const { currentUser } = this.props;
    const { language, proeficiency, languages } = this.state;

    return (
      <>
        {languages.map(({ language, proeficiency }) => (
          <XPItem companyName={proeficiency} jobPosition={language} />
        ))}
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridLanguage">
              <Form.Label style={{ fontWeight: 'bold' }}>Idioma</Form.Label>
              <Form.Control
                type="text"
                value={language || ''}
                onChange={this.handleLanguage}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridInitialDate">
              <Form.Label style={{ fontWeight: 'bold' }}>
                Proeficiência
              </Form.Label>
              <Form.Control
                as="select"
                defaultValue={proeficiency || 'Proeficiência'}
                onChange={this.handleProeficiency}
              >
                <option>Proeficiência</option>
                <option value="Básico">Básico</option>
                <option value="Intermediário">Intermediário</option>
                <option value="Avançado">Avançado</option>
                <option value="Fluente">Fluente</option>
              </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col}>
              <Button onClick={this.onSaveChanges}>Adicionar</Button>
            </Form.Group>
          </Form.Row>
        </Form>
      </>
    );
  }
}

export default LanguageForm;
